<template>
  <div>
    <Form ref="activeReport" :dataSource="getForm" id="activeReport"></Form>
  </div>
</template>

<script>
import { forms } from './formData'
// import axios from 'axios'
import Form from '@/components/GlobalForm'
import { uploadProcessFile, delProcessFile } from '@/api/compositeAssit.js'
export default {
  name: 'Index',
  components: {
    Form
  },
  props: {
    checkDisabled: {
      type: Function,
      default: () => { }
    },
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    planTemplateFiles: {
      type: Array,
      default: () => {
        return []
      }
    },
    projectPlanFiles: {
      type: Array,
      default: () => {
        return []
      }
    },
    workFlowNumber: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      files: this._.cloneDeep(this.fileList) || []
    }
  },
  watch: {
    fileList(value) {
      this.files = this._.cloneDeep(value) || []
    }
  },
  mounted() {
    this.files = this._.cloneDeep(this.fileList) || []
  },
  computed: {
    getForm() {
      return forms.getBaseForm(this)
    }
  },
  methods: {
    upload(data) {
      const formData = new FormData()
      formData.append('files', data.file)
      formData.append('process_config_type', this.workFlowNumber.process_config_type)
      formData.append(
        'process_base_work_flow_number',
        this.workFlowNumber.process_base_work_flow_number
      )
      return new Promise((resolve, reject) => {
        uploadProcessFile(formData).then((response) => {
          this.$notification.success({
            message: '文件上传成功'
          })
          var hebingArr = this.planTemplateFiles.concat(this.projectPlanFiles)
          const cacheArr = response.filter(x => !hebingArr.some(y => y.report_file_id === x.report_file_id))
          this.files = cacheArr
        })
      })
    },
    downLoad(data) {
      // 文件下载
      window.open(
        process.env.VUE_APP_API_BASE_URL +
        '/process/downloadProcessFile?report_file_id=' +
        data.report_file_id
      )
    },
    onDelete(data) {
      // 文件删除
      const params = {
        process_base_work_flow_number: data.process_base_work_flow_number,
        report_file_id: data.report_file_id
      }
      delProcessFile(params).then((response) => {
        this.$notification.success({
          message: '文件删除成功'
        })
        var hebingArr = this.planTemplateFiles.concat(this.projectPlanFiles)
        const cacheArr = response.filter(x => !hebingArr.some(y => y.report_file_id === x.report_file_id))
        this.files = cacheArr
      })
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$notification.success({
          message: '文件上传成功'
        })
        this.files = info.fileList
      } else if (info.file.status === 'error') {
        this.$notification.error({
          message: '文件上传失败'
        })
      }
    }, // 文件上传的改变
    getValue() {
      return { fileList: this.files }
    }
  }
}
</script>

<style scoped></style>
